import { render, staticRenderFns } from "./Opcoes.vue?vue&type=template&id=b408d488&scoped=true"
import script from "./Opcoes.vue?vue&type=script&lang=js"
export * from "./Opcoes.vue?vue&type=script&lang=js"
import style0 from "./Opcoes.vue?vue&type=style&index=0&id=b408d488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b408d488",
  null
  
)

export default component.exports